const onCompleteFunc = position => {
  switch(parseInt(position)) {
  case 0:
    focusFirstFormField('register_user')
    setTabIndicesOnChildren(position, '')
    setTabIndicesOnChildren(2, '-1')
    break;
  case 1: /* --- MAIN PANEL --- */
    setTabIndicesOnChildren(2, '-1')
    setTabIndicesOnChildren(0, '-1')
    break;
  case 2:
    focusFirstFormField('login_user')
    setTabIndicesOnChildren(position, '')
    setTabIndicesOnChildren(0, '-1')
    break;
  default:
    console.log('Unsupported position:', position, '-- Valid positions: 0, 1, 2')
    break;
  }
};

const focusFirstFormField = id => {
  const formContainer = document.getElementById(id)
  const firstField = formContainer.querySelector('input[type="email"]') ||
                       formContainer.querySelector('input[type="text"]')
  firstField.focus()
}

const setTabIndicesOnChildren = (position, value) => {
  const container = document.getElementById(`hero_panel${position}`)

  container.querySelectorAll('a').forEach(a => setTabindex(a, value))
  container.querySelectorAll('input').forEach(i => setTabindex(i, value))
  container.querySelectorAll('button').forEach(b => setTabindex(b, value))
}

const setTabindex = (el, value) => el.setAttribute('tabindex', value)

const delegateEvents = () => {
  const slideTriggers = document.querySelectorAll('.js-slide-hero');
  slideTriggers.forEach(t => t.addEventListener('click', moveTo))
};

const applyPosition = position => {
  const positions = [
    { left: '0%' },
    { left: '-100%' },
    { left: '-200%' }
  ];

  const slidePanel = document.querySelector('.js-slide-hero__panel');

  const nextPosition = positions[position];

  const animOptions = Object.assign(
    {},
    nextPosition,
    {
      ease: Quint.easeInOut,
      onComplete: onCompleteFunc.bind(this, position)
    }
  );

  TweenLite.to(slidePanel, 0.75, animOptions);
};

const moveTo = event => {
  event.preventDefault();
  applyPosition(event.currentTarget.dataset.moveTo)
};

export default {
  init(node) {
    delegateEvents();
  }
};
